import { truncateText } from '../../utils/string-utils';
import { initDatalayerElement } from '../tracking/datalayer';

const DEFAULT_ELEMENTS_TO_RENDER_RAIL = 4;
const spaceString = ' ';

export const init = ($parselyTopVideo) => {
  const { url: parselyUrl, position, contenttype: contentType, heading, target } = $parselyTopVideo.dataset;
  let { parselyintcmp: parselyIntcmp, hreflink: hrefLink, hreflabel: hrefLabel } = $parselyTopVideo.dataset;

  parselyIntcmp = parselyIntcmp ? String(parselyIntcmp) : ' ';
  hrefLink = hrefLink ? String(hrefLink) + spaceString : ' ';
  hrefLabel = hrefLabel ? String(hrefLabel) + spaceString : ' ';

  if (position === 'rail' && contentType === 'video') {
    const railMarkup = () => {
      return `<div class="c-rail-content__top">
                  <h2 class="c-section-title " data-shadow="${heading}">${heading}</h2>
                </div>
      <div class="c-set-of-cards c-set-of-cards--R4B  c-set-of-cards--bg-transparent-text-light-m c-set-of-cards--bg-transparent-text-light-t c-set-of-cards--bg-transparent-text-light-d c-set-of-cards--border-custom-d" id="railCard">
      </div>
      ${
        hrefLink !== ' '
          ? ` <div class="c-rail-content__bottom o-distributed--right-t o-distributed--right-d">
        <a class="c-cta c-cta--secondary" href="${hrefLink}" target="${target}">
          <span class="c-cta__text">
            ${hrefLabel}
          </span>
        </a>
      </div>`
          : ``
      }`;
    };

    document.querySelector('#parselyTemplateVideos').innerHTML = railMarkup();

    const cardMarkupRail = (Title, Image, Link) => {
      return `<a class="c-card c-card--base c-card--CA15-m c-card--CA05C-t c-card--CA05C-d" href="${Link}">
      <article class="c-card__wrapper">
        <div class="c-card__content">
          <h2 class="c-card__title">${Title}</h2>
        </div>
        <div class="c-card__img-wrapper">
          <figure class="o-aspect-ratio o-aspect-ratio--16-9">
            <img  crossorigin="anonymous" class="c-card__img j-lazyload" alt="${Title}" src="${Image}">
          </figure>
          <i class="icon icon--media icon--play icon--medium icon--c-primary">
            <svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" class="icon__svg icon__svg--play">
              <path d="M13 4.812c0-1.094.372-2.155 1.053-3.01a4.783 4.783 0 0 1 6.74-.745l43.744 35.188a4.824 4.824 0 0 1 0 7.51L20.793 78.943A4.784 4.784 0 0 1 17.795 80C15.147 80 13 77.845 13 75.188V4.812z">
              </path>
            </svg>
          </i>
        </div>
      </article>
    </a>`;
    };

    let cards = ``;
    fetch(parselyUrl)
      .then((resp) => resp.json())
      .then((json) => {
        let parselyMeta = json;
        const jsonIndex = json.length;
        if (jsonIndex === 0) {
          document.querySelector('#parselyTemplateVideos').style.display = 'none';
        } else if (jsonIndex <= DEFAULT_ELEMENTS_TO_RENDER_RAIL && jsonIndex >= 1) {
          parselyMeta = json;
        } else {
          parselyMeta = json.slice(0, DEFAULT_ELEMENTS_TO_RENDER_RAIL);
        }
        parselyMeta.forEach((data) => {
          let title = data.Title;
          title = truncateText(title, 50);
          const image = data.Image;
          let link = data.Link;
          link = link + parselyIntcmp;
          const htmlCard = cardMarkupRail(title, image, link);
          cards = cards + htmlCard;
        });
        const $railCard = document.querySelector('#railCard');
        $railCard.innerHTML = cards;
        /**
         * Initialize Datalayer Intcmp/Zoneid
         */
        initDatalayerElement($railCard);
      })
      .catch((error) => {
        throw error;
      });
  }
};
